import {
  QUOTE_REQUEST_FAILED,
  QUOTE_REQUEST_START,
  QUOTE_REQUEST_SUCCESS,
  QUOTE_INDIVIDUAL_REQUEST_START,
  CALCULATE_INDIVIDUAL_REQUEST_START,
  COVERME_CLEAR_QUOTEDATA,
  QuoteStore,
  QuoteStoreResponse,
  QuoteResponse,
  QUOTE_INDIVIDUAL_REQUEST_FAILED,
  QUOTE_INDIVIDUAL_REQUEST_SUCCESS
} from './types';
import { filter, map, reduce, toString } from 'lodash';
import { getQuoteError } from './utils';
import { RESET_STORE, STORE, WhitelistAction } from '../global';
import { checkWhitelist } from '../reducer-utils';

const initialState: QuoteStore = {};

export const quote = (
  state: QuoteStore = {},
  action: {
    type: string;
    payload?: unknown;
  } = { type: '', payload: '' }
): QuoteStore => {
  switch (action.type) {
    case QUOTE_REQUEST_START: {
      const act = action.payload as Array<number>;
      return {
        ...state,
        quoteFetched: false,
        quoteError: false,
        quoteServerError: false,
        ...reduce(
          act,
          (res, paxRef) => ({
            ...res,
            [paxRef]: {
              loading: true,
              referenceNumber: paxRef
            }
          }),
          {}
        )
      };
    }
    case QUOTE_REQUEST_SUCCESS: {
      return {
        ...state,
        quoteFetched: true,
        quoteError: getQuoteError(action.payload),
        quoteServerError: false,
        ...mapQuoteResponseToPax(action.payload as QuoteResponse)
      };
    }
    case QUOTE_REQUEST_FAILED: {
      const act = action.payload as QuoteStoreResponse[];
      return {
        ...state,
        quoteFetched: true,
        quoteError: true,
        quoteServerError: true,
        ...changeToIndividual(act)
      };
    }
    case QUOTE_INDIVIDUAL_REQUEST_START: {
      const act = action.payload as number;
      const existing = state[act];
      return {
        ...state,
        [act]: { ...existing, loading: true }
      };
    }
    case CALCULATE_INDIVIDUAL_REQUEST_START: {
      const act = action.payload as number;
      const existing = state[act];
      return {
        ...state,
        quoteError: false,
        [act]: { ...existing, calculate: true }
      };
    }
    /**
     *  TO DO: To be synced with BE for optimization
     *  Possible idea: add a new field for companion count to be used in re-quoting for individual tripParams
     **/
    case QUOTE_INDIVIDUAL_REQUEST_SUCCESS:
    case QUOTE_INDIVIDUAL_REQUEST_FAILED: {
      const act = action.payload as QuoteStoreResponse;
      const refNum = act.referenceNumber;
      const individualPax = filter(
        act.quoteData.paxes,
        ({ referenceNumber }) => toString(referenceNumber) === toString(refNum)
      );
      return {
        ...state,
        [refNum]: {
          ...act,
          quoteData: {
            ...act.quoteData,
            paxes: individualPax
          }
        }
      };
    }
    case COVERME_CLEAR_QUOTEDATA: {
      state = {};
      return {
        ...state
      };
    }
    case RESET_STORE: {
      // Honour resetStore() so the deep-link/agent hand-off flow (and any
      // future full-reset caller) gets a truly fresh slice instead of leaking
      // stale `quoteFetched: true` into the next render — which caused
      // QuoteDetails to skip its loading gate and crash on
      // `quoteForm.coverageDaysGood`.
      const { whitelist } = (action.payload ?? {}) as WhitelistAction;
      return checkWhitelist(whitelist, STORE.QUOTE, state, initialState) as QuoteStore;
    }
    default:
      return state;
  }
};

export const changeToIndividual = (act: QuoteStoreResponse[]) =>
  reduce(
    act,
    (res, paxRef) => ({
      ...res,
      [paxRef.referenceNumber]: paxRef
    }),
    {}
  );

export const mapQuoteResponseToPax = (input: QuoteResponse) =>
  changeToIndividual(
    map(input.paxes, pax => {
      const { paxes, ...rest } = input;
      return {
        quoteData: {
          ...rest,
          paxes: [pax]
        },
        calculate: false,
        loading: false,
        referenceNumber: pax.referenceNumber
      };
    })
  );
